// extracted by mini-css-extract-plugin
export default {"button":"PomodoroToggle_button__u8FpK","start":"PomodoroToggle_start__5nz2U","stop":"PomodoroToggle_stop__PUNpt"};